import type { ReactNode } from 'react';
import type { Portfolio } from '@/hooks/portfolio/usePortfolio';

type Props = {
  portfolio: Portfolio;
  children: ReactNode;
};

export const RestrictedTabPanel = ({ portfolio, children }: Props) => {
  if (portfolio.isAnalysisRestricted) {
    return null;
  }
  return children;
};
